import { render, staticRenderFns } from "./PriceGroups.vue?vue&type=template&id=128f2503&scoped=true"
import script from "./PriceGroups.vue?vue&type=script&lang=js"
export * from "./PriceGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128f2503",
  null
  
)

export default component.exports